export var SELECTION_CHANGE = 'change';
export var SELECTION_ITEMS_CHANGE = 'items-change';
/**
 * {@docCategory Selection}
 */
export var SelectionMode;
(function (SelectionMode) {
  SelectionMode[SelectionMode["none"] = 0] = "none";
  SelectionMode[SelectionMode["single"] = 1] = "single";
  SelectionMode[SelectionMode["multiple"] = 2] = "multiple";
})(SelectionMode || (SelectionMode = {}));
/**
 * {@docCategory Selection}
 */
export var SelectionDirection;
(function (SelectionDirection) {
  SelectionDirection[SelectionDirection["horizontal"] = 0] = "horizontal";
  SelectionDirection[SelectionDirection["vertical"] = 1] = "vertical";
})(SelectionDirection || (SelectionDirection = {}));